import React, {FC, useMemo} from 'react';
import FormGroup from '@mui/material/FormGroup';
import EntityField from './custom_fields/EntityField';
import {
  TextField,
  SelectField,
  MultiSelectField
} from '../../../../../common/formik/fields';
import {TaskField, TaskFieldRequiredState} from '../../../../../../constants/tasks';
import {getSpecificQuestionPropsByType} from './helpers/getSpecificQuestionPropsByType';
import {FormattedFormField} from '../../../../types';
import DateTimePickerField from '../../../../../common/formik/fields/DateTimePickerField';
import DatePickerField from '../../../../../common/formik/fields/DatePickerField';

const questionTypeToFormField = {
  [TaskField.TEXT]: TextField,
  [TaskField.SELECT]: SelectField,
  [TaskField.MULTI_SELECT]: MultiSelectField,
  [TaskField.OPERATORY_SELECT]: EntityField,
  [TaskField.TREATMENT_SELECT]: EntityField,
  [TaskField.DATE_TIME]: DateTimePickerField,
  [TaskField.DATE]: DatePickerField
};

type QuestionProps = {
  field: FormattedFormField,
  disabled: boolean
};

const Question: FC<QuestionProps> = ({field, disabled}) => {
  const {type, name, id, required, details, validationType} = field || {};
  const {options} = details || {};

  const Component = questionTypeToFormField[type];

  if (!Component) {
    return null;
  }

  const specificQuestionProps = useMemo(() =>
    getSpecificQuestionPropsByType(type, details),
  [type, details]);

  const isRequired = required === TaskFieldRequiredState.REQUIRED ||
  required === TaskFieldRequiredState.REQUIRED_BY_CONDITION;

  return (
    <FormGroup className="form-group">
      <Component
        size="small"
        name={`${id}`}
        required={isRequired}
        options={options || []}
        label={name}
        disabled={disabled}
        type={type}
        validationType={validationType}
        {...specificQuestionProps}
      />
    </FormGroup>
  );
};

export default Question;
